<template>
  <div class='main'>
    <div class='menuContainer' :style="`width:${isHidden?'0':'221px'}`">
      <div class='hiddenIcon' @click='hiddenTab'>
        <i :class="isHidden?'el-icon-caret-right':'el-icon-caret-left'" style='color:#fff' />
      </div>
      <el-menu
        :default-active='pathActive'
        text-color='#335483'
        active-text-color='#fff'
        :unique-opened='true'
        style='width: 221px'
        :style="`transform:translateX(${isHidden?'-221px':'0'});transition: all .3s;`"
        @select='selectMenu'
        router
      >
        <el-submenu index='/audit/entrust' v-has='"pc_auditor_manage"'>
          <template slot='title'>
            <i class='el-icon-s-tools' style='color:#335483' />
            <span>审核管理</span>
          </template>
          <el-menu-item-group v-has='"pc_auditor_consignor_info"'>
            <el-menu-item index='/audit/entrust'>委托商审核</el-menu-item>
          </el-menu-item-group>
          <!-- <el-menu-item-group v-if="auditMenu.indexOf('运输车审核')>-1">
            <el-menu-item index="/audit/transportCar">运输车审核</el-menu-item>
          </el-menu-item-group> -->
          <el-menu-item-group v-has='"pc_auditor_highway_info"'>
            <el-menu-item index='/audit/highWay'>公路供应商审核</el-menu-item>
          </el-menu-item-group>
          <!-- <el-menu-item-group >
            <el-menu-item index="/audit/audit">合同审核</el-menu-item>
          </el-menu-item-group> -->
<!--          <el-menu-item-group v-has='"pc_auditor_supplier_rk"'>
            <el-menu-item index='/audit/day'>供应商日考审核</el-menu-item>
          </el-menu-item-group>-->
          <el-menu-item-group v-has='"pc_auditor_supplier_yk"'>
            <el-menu-item index='/audit/month'>供应商月考审核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_auditor_contract_price"'>
            <el-menu-item index='/audit/price'>合同价格审核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_auditor_supplier_px"'>
            <el-menu-item index='/audit/supplierTrain'>供应商培训审核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_auditor_settlement_info"'>
            <el-menu-item index='/audit/settle'>结算审核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_auditor_payment"'>
            <el-menu-item index='/audit/pay'>付款审核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_auditor_other_fees"'>
            <el-menu-item index='/audit/otherFees'>其他费用审核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_auditor_deduct"'>
            <el-menu-item index='/audit/deductCost'>抵扣开票费用审核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_auditor_port"'>
            <el-menu-item index='/audit/fuelCost' :route="{name:'fuelCost',params:{type:0}}">燃油费审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_auditor_account_recon"'>
            <el-menu-item index='/audit/accountStatement'>对账单审核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_reexamine_account_recon"'>
            <el-menu-item index='/audit/statementReview'>对账单复核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has='"pc_auditor_child_update"'>
            <el-menu-item index='/audit/dataModification'>数据修改审核</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index='/audit/change'>变更审核</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/audit/financialAudit' v-has="'pc_auditor_manage'">
          <template slot='title' v-has="'pc_auditor_settlement'">
            <i class='el-icon-s-tools' style='color:#335483' />
            <span>财务审核</span>
          </template>
          <el-menu-item-group v-has="'pc_auditor_settlement'">
            <el-menu-item index='/audit/vehicleSettlement'> 整车结算</el-menu-item>
          </el-menu-item-group>
<!--          <el-menu-item-group v-has="'pc_auditor_settlement'">
            <el-menu-item index='/audit/financialSupervision'>金融监管</el-menu-item>
          </el-menu-item-group>-->
        </el-submenu>
<!--        <el-submenu index='/audit/vehicleAudit' v-has="'pc_auditor_plan_logistic'">-->
<!--          <template slot='title' v-has="'pc_auditor_plan_logistic'">-->
<!--            <i class='el-icon-s-tools' style='color:#335483' />-->
<!--            <span>整车物流审核</span>-->
<!--          </template>-->
<!--          <el-menu-item-group v-has="'pc_auditor_plan_review'">-->
<!--            <el-menu-item index='/audit/monthlyPlanReview'>年月计划审核</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-submenu>-->
        <el-submenu index='/audit/entrustAudit' v-has="'pc_auditor_basics'">
          <template slot='title' v-has="'pc_auditor_basics'">
            <i class='el-icon-user-solid' style='color:#335483' />
            <span>基础档案人员管理</span>
          </template>
          <el-menu-item-group v-has="'pc_auditor_consignor'">
            <el-menu-item index='/audit/entrustAudit'
                          :route="{name:'entrustAudit',params:{type:1}}">委托商审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_auditor_highway'">
            <el-menu-item index='/audit/highWayAudit'
                          :route="{name:'highWayAudit',params:{type:2}}">公路供应商审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_auditor_truck'">
            <el-menu-item index='/audit/transporter' :route="{name:'transporter',params:{type:3}}">
              运输车审核
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/audit/contractAudit' v-has="'pc_auditor_business'">
          <template slot='title' v-has="'pc_auditor_business'">
            <i class='el-icon-user-solid' style='color:#335483' />
            <span>商务合规人员管理</span>
          </template>
          <el-menu-item-group v-has="'pc_auditor_price'">
            <el-menu-item index='/audit/auditPrice' :route="{name:'auditPrice',params:{type:10}}">
              价格评审审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_auditor_daily'">
            <el-menu-item index='/audit/dailyCheck' :route="{name:'dailyCheck',params:{type:11}}">
              供应商日考审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_auditor_monthly'">
            <el-menu-item index='/audit/moonCheck' :route="{name:'moonCheck',params:{type:12}}">
              供应商月考审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_auditor_year'">
            <el-menu-item index='/audit/yearCheck' :route="{name:'yearCheck',params:{type:13}}">
              供应商年考审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_auditor_train'">
            <el-menu-item index='/audit/training' :route="{name:'training',params:{type:14}}">
              供应商培训审核
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/audit/yearPlan' v-has="'pc_auditor_logistic'">
          <template slot='title' v-has="'pc_auditor_logistic'">
            <i class='el-icon-user-solid' style='color:#335483' />
            <span>整车物流人员管理</span>
          </template>
          <el-menu-item-group v-has="'pc_auditor_massLoss'">
            <el-menu-item index='/audit/qualityLoss' :route="{name:'qualityLoss',params:{type:21}}">
              质损审核
            </el-menu-item>
          </el-menu-item-group>
<!--          <el-menu-item-group v-has="'pc_plan_review'">-->
<!--            <el-menu-item index='/audit/monthlyPlan' :route="{name:'monthlyPlan',params:{type:20}}">-->
<!--              年月计划审核-->
<!--            </el-menu-item>-->
<!--          </el-menu-item-group>-->
          <el-menu-item-group v-has="'pc_change'">
            <el-menu-item index='/audit/changeReview' :route="{name:'changeReview',params:{type:88}}">
              变更审核
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index='/audit/otherCost' v-has="'pc_auditor_settlement'">
          <template slot='title' v-has="'pc_auditor_settlement'">
            <i class='el-icon-user-solid' style='color:#335483' />
            <span>结算管理人员管理</span>
          </template>
          <el-menu-item-group v-has="'pc_auditor_reconciliation'">
            <el-menu-item index='/audit/otherCost' :route="{name:'otherCost',params:{type:30}}">
              其他费用审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_auditor_billing'">
            <el-menu-item index='/audit/deduct' :route="{name:'deduct',params:{type:31}}">抵扣开票费用审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_auditor_fuel_cost'">
            <el-menu-item index='/audit/fuelCostReview'
                          :route="{name:'fuelCostReview',params:{type:32}}">燃油费审核
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-has="'pc_auditor_account_statement'">
            <el-menu-item index='/audit/personAccountStatement'
                          :route="{name:'personAccountStatement',params:{type:33}}">对账单审核
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div class='content2' :style="`width:${isHidden?'100%':'calc(100% - 221px)'}`">
      <router-view v-if="$route.path.split('/').length>=3" />
      <Home v-else />
      <div class='footer-div'>渝ICP备2022002327号-1</div>
    </div>
  </div>
</template>

<script>
  import Home from '@/views/home/main.vue';
  import { getSessionStore } from '@/config/mUtils';

  export default {
    components: {
      Home,
    },

    data() {
      return {
        pathActive: null,
        activeNum: 1,
        isHidden: false,
        auditMenu: [],
      };
    },
    watch: {
      $route(to, from) {
        console.log(to, from);
        this.pathActive = this.$route.path;
      },
    },
    mounted() {
      this.pathActive = this.$route.path;
      this.auditMenu = this.getFields(JSON.parse(getSessionStore('auditMenu')).childList, 'title');
      console.log(this.auditMenu);
    },
    methods: {
      hiddenTab() {
        this.isHidden = !this.isHidden;
      },
      selectMenu() {
        this.activeNum = 0;
      },
      getFields(input, field) {
        const output = [];
        for (let i = 0; i < input.length; ++i) {
          output.push(input[i][field]);
        }
        return output;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;

    .menuContainer {
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      position: relative;
      transition: all .3s;
      height: calc(100vh - 70px);
      overflow-x: hidden;

      .hiddenIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #48599E;
        width: 11px;
        height: 50px;
        position: absolute;
        top: calc(50% - 20px);
        right: -11px;
        border-radius: 0 10px 10px 0;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .content {
      width: calc(100% - 221px);
      height: calc(100vh - 70px);
      overflow: auto;
    }

    .content2 {
      transition: all .3s;
      width: 100%;
      height: calc(100vh - 70px);
      overflow: auto;
    }

    ::v-deep {
      .el-menu-item.is-active {
        background-color: #335483;
      }

      .el-menu-item:focus {
        outline: 0;
        background-color: #335483;
      }
    }

    .content2 > .contract-list, .content2 > .electrify,
    .content2 > .operation, .content2 > .consignSettle,
    .content2 > .portSettle, .content2 > .stockpile,
    .content2 > .warehouse, .content2 > .deferlnvoicing,
    .content2 > .massLoss-list, .content2 > .logisticsConfig,
    .content2 > .finance-income, .content2 > .price-highway,
    .content2 > .main, .content2 > .supplierTrain,
    .content2 > .otherFees, .content2 > .mainContainer,
    .content2 > .data-modification {
      height: calc(100% - 30px);
      overflow-y: auto;
    }

    .footer-div {
      display: block;
      position: relative;
      bottom: 0px;
      left: 0px;
      width: 100%;
      height: 30px;
      font-size: 13px;
      line-height: 30px;
      text-align: center;
      color: #a8a8a8;
      background-color: #f4f7fb;
    }
  }
</style>
